import { useEffect, useRef, useState } from "react";

/**
 * Adds the "is-visible" class (see .mk-reveal in index.css) once the
 * returned ref scrolls into view, so marketing sections fade/rise in
 * instead of all appearing at once. Fires once and disconnects — this is
 * a one-way reveal, not a re-triggering scroll animation.
 */
export default function useScrollReveal(options) {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    if (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      setIsVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15, ...options },
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [options]);

  return [ref, isVisible];
}
